import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type {
    VistoTemporarioSolicitacaoAtualizacaoPeriodoEEnderecosRequest,
    VistoTemporarioSolicitacaoAssuntoFinalidadeResponse,
    VistoTemporarioSolicitacaoCadastroRequest,
    VistoTemporarioSolicitacaoCadastroResponse,
    VistoTemporarioSolicitacaoEnderecoResponse,
    VistoTemporarioSolicitacaoJaSolicitadoResponse,
    VistoTemporarioSolicitacaoMedicoResponse,
    VistoTemporarioSolicitacaoPeriodoResponse,
    VistoTemporarioSolicitacaoPesquisaRequest,
    VistoTemporarioSolicitacaoPesquisaResponse,
    VistoTemporarioSolicitacaoSolicitanteResponse
} from './visto-temporario-solicitacao.model';

@Injectable({ providedIn: 'root' })
export class VistoTemporarioSolicitacaoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.vistoTemporario.solicitacoes;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    pesquisarSolicitacoes(body: VistoTemporarioSolicitacaoPesquisaRequest, context?: HttpContext): Observable<VistoTemporarioSolicitacaoPesquisaResponse[]> {
        return this.http.post<VistoTemporarioSolicitacaoPesquisaResponse[]>(this.PATH, body, { context });
    }

    cadastrarSolicitacao(body: VistoTemporarioSolicitacaoCadastroRequest, context?: HttpContext): Observable<VistoTemporarioSolicitacaoCadastroResponse> {
        return this.http.post<VistoTemporarioSolicitacaoCadastroResponse>(`${this.PATH}/cadastro`, body, { context });
    }

    buscarSolicitantesPorProtocolo(idProtocolo: number, context?: HttpContext): Observable<VistoTemporarioSolicitacaoSolicitanteResponse[]> {
        return this.http.get<VistoTemporarioSolicitacaoSolicitanteResponse[]>(`${this.PATH}/${idProtocolo}/solicitantes`, { context });
    }

    buscarSolicitanteInteressadoPorProtocolo(idProtocolo: number, context?: HttpContext): Observable<VistoTemporarioSolicitacaoSolicitanteResponse[]> {
        return this.http.get<VistoTemporarioSolicitacaoSolicitanteResponse[]>(`${this.PATH}/${idProtocolo}/solicitante-interessado`, { context });
    }

    buscarAssuntoFinalidadePorProtocolo(idProtocolo: number, context?: HttpContext): Observable<VistoTemporarioSolicitacaoAssuntoFinalidadeResponse[]> {
        return this.http.get<VistoTemporarioSolicitacaoAssuntoFinalidadeResponse[]>(`${this.PATH}/${idProtocolo}`, { context });
    }

    buscarPeriodosPorProtocolo(idProtocolo: number, context?: HttpContext): Observable<VistoTemporarioSolicitacaoPeriodoResponse[]> {
        return this.http.get<VistoTemporarioSolicitacaoPeriodoResponse[]>(`${this.PATH}/${idProtocolo}/periodos`, { context });
    }

    buscarEnderecosPorProtocoloETipo(idProtocolo: number, inTipoEndereco: 'C' | 'T', context?: HttpContext): Observable<VistoTemporarioSolicitacaoEnderecoResponse[]> {
        return this.http.get<VistoTemporarioSolicitacaoEnderecoResponse[]>(`${this.PATH}/${idProtocolo}/enderecos/${inTipoEndereco}`, { context });
    }

    buscarMedicosPorProtocolo(idProtocolo: number, context?: HttpContext): Observable<VistoTemporarioSolicitacaoMedicoResponse[]> {
        return this.http.get<VistoTemporarioSolicitacaoMedicoResponse[]>(`${this.PATH}/${idProtocolo}/medicos`, { context });
    }

    buscarVistosJaSolicitadosPorMedico(idSolicitante: number, ufSgUf: string, idProtocolo: number, context?: HttpContext): Observable<VistoTemporarioSolicitacaoJaSolicitadoResponse[]> {
        return this.http.get<VistoTemporarioSolicitacaoJaSolicitadoResponse[]>(`${this.PATH}/medicos/${idSolicitante}/${ufSgUf}/vistos-solicitados/${idProtocolo}`, { context });
    }

    atualizarPeriodoEEnderecos(body: VistoTemporarioSolicitacaoAtualizacaoPeriodoEEnderecosRequest, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/periodos/enderecos`, body, { context });
    }
}
